// components/Header/Header.js
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import MenuHamburger from "./Menu/Menu";

import "./Header.css";
import LogoTextFlama from "../../assets/logo-text-flama";
import LogoFlama from "../../assets/logo-flama.js";

function Header() {
  const [scrollDirection, setScrollDirection] = useState("up");
  const [prevScrollY, setPrevScrollY] = useState(0);

  // Usar useLocation para obtener la ruta actual
  const location = useLocation();
  // Verificar si estamos en una pagina con fondo blanco
  const isWhiteBackground =
    location.pathname === "/agenda" ||
    location.pathname === "/qui-som" ||
    location.pathname === "/entitats" ||
    location.pathname === "/botiga";
  const isContactPage = location.pathname === "/contact";

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollThreshold = 5;

      if (currentScrollY > prevScrollY + scrollThreshold) {
        setScrollDirection("down");
      } else if (currentScrollY < prevScrollY - scrollThreshold) {
        setScrollDirection("up");
      }

      setPrevScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollY]);

  return (
    <header className={`header scroll-${scrollDirection}`}>
      <div className="header-container">
        <Link to="/" className="header-logo link-without-underline">
          <LogoTextFlama
            fillColor={isWhiteBackground ? "#5abd63" : undefined}
          />
        </Link>
        <Link to="/" className="header-center-logo link-without-underline">
          <LogoFlama
            height={55}
            width={55}
            color={isContactPage ? "#f7f6eb" : undefined}
          />
        </Link>
        <MenuHamburger />
      </div>
    </header>
  );
}

export default Header;
